import LegalLayout, { H2, P, UL } from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" updated="30 Aug 2026">
      <div className="glass p-4 sm:p-5 border-l-4 border-l-[#F59E0B] mb-6">
        <P>
          <strong>Summary: all sales are final. rsell ai does not issue refunds</strong> — for unused credits, partial billing periods, or accidental purchases. This is disclosed here and at checkout before you pay.
        </P>
      </div>

      <H2>Why no refunds</H2>
      <P>
        rsell ai delivers digital goods (AI-generated pricing reports and credits) that are consumed immediately and cannot be "returned". EU distance-selling rules recognise this and allow us to disclaim the 14-day withdrawal right once the service is delivered and consumed, provided we tell you in advance — which is what this page does.
      </P>

      <H2>What this means in practice</H2>
      <UL>
        <li><strong>Subscriptions</strong> — no partial-month or pro-rata refunds when you cancel. Your credits stay usable until the end of the paid period.</li>
        <li><strong>One-off purchases</strong> — no refund once you complete the Whop checkout, regardless of how many credits you use.</li>
        <li><strong>Duplicate charges from Whop</strong> — the one exception. If Whop double-charges you, email us with the two payment IDs and we'll cancel the extra charge. Contact <a href="mailto:rsell.ai.real@gmail.com" className="text-[#10B981] underline">rsell.ai.real@gmail.com</a>.</li>
        <li><strong>Service outage</strong> — if we have a documented outage lasting more than 24 consecutive hours, we'll extend your subscription by the equivalent time as a credit.</li>
      </UL>

      <H2>Cancelling your subscription</H2>
      <P>
        You can cancel at any time from your Whop dashboard or by emailing us. Cancellation takes effect at the end of your current billing period; you keep access and any remaining credits until then.
      </P>

      <H2>Chargebacks</H2>
      <P>
        If you initiate a chargeback with your bank or card issuer instead of contacting us first, your account will be suspended pending resolution. We recommend emailing us at <a href="mailto:rsell.ai.real@gmail.com" className="text-[#10B981] underline">rsell.ai.real@gmail.com</a> before disputing — most issues are faster to resolve directly.
      </P>

      <H2>Consumer rights</H2>
      <P className="!text-white/60 text-sm">
        Nothing in this policy limits statutory consumer rights that cannot be waived under EU law. If you believe your rights have been infringed you can contact the State Consumer Rights Protection Authority (Valstybinė vartotojų teisių apsaugos tarnyba) in Lithuania.
      </P>
    </LegalLayout>
  );
}
